import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const images = [
  {
    url: "https://images.pexels.com/photos/5201109/pexels-photo-5201109.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
    alt: "Blue corn tacos",
  },
  {
    url: "https://images.unsplash.com/photo-1695088224233-69cc4f3b19cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxkYXJrJTIwZm9vZCUyMHBob3RvZ3JhcGh5JTIwbWV4aWNhbiUyMGN1aXNpbmV8ZW58MHx8fHwxNzcxOTY0Nzk1fDA&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
    alt: "Salsa with tortillas",
  },
  {
    url: "https://images.unsplash.com/photo-1629741884398-68d755d34404?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZm9vZCUyMHBob3RvZ3JhcGh5JTIwbWV4aWNhbiUyMGN1aXNpbmV8ZW58MHx8fHwxNzcxOTY0Nzk1fDA&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
    alt: "Grilled meat plating",
  },
  {
    url: "https://images.pexels.com/photos/8448066/pexels-photo-8448066.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
    alt: "Street food tortilla",
  },
  {
    url: "https://images.unsplash.com/photo-1695088224722-3e9133446c12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxkYXJrJTIwZm9vZCUyMHBob3RvZ3JhcGh5JTIwbWV4aWNhbiUyMGN1aXNpbmV8ZW58MHx8fHwxNzcxOTY0Nzk1fDA&ixlib=rb-4.1.0&q=85&w=400&h=400&fit=crop",
    alt: "Chili soup bowl",
  },
  {
    url: "https://images.pexels.com/photos/27603263/pexels-photo-27603263.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
    alt: "Vibrant tacos presentation",
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
};

export default function InstagramGrid() {
  return (
    <section
      data-testid="instagram-section"
      className="relative py-24 md:py-32"
      style={{ backgroundColor: "#1A1A1A" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <Instagram size={20} className="text-[#E07A5F]" />
            <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37]">
              @puramadre
            </p>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-[#F5F5F0] tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Alimenta tu <span className="text-[#E07A5F]">Alma</span>
          </h2>
        </motion.div>

        {/* Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3"
        >
          {images.map((img, i) => (
            <motion.div
              key={i}
              variants={itemVariants}
              className="insta-item aspect-square cursor-pointer group relative"
              data-testid={`instagram-item-${i}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              {/* Hover overlay with icon */}
              <div className="absolute inset-0 bg-[#1A1A1A]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center z-10">
                <Instagram size={24} className="text-[#D4AF37]" />
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
